const skills = [
  {
    name: "HTML",
    id:0,
    iconName: "logos:html-5",
    value: 90,
    imageUrl:
      "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_960_720.png",
  },
  {
    id:1,
    name: "CSS",
    iconName: "logos:css-3",
    value: 90,
    imageUrl:
      "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_960_720.png",
  },
  {
    id:2,
    name: "Javascript",
    iconName: "logos:javascript",
    value: 90,
    imageUrl:
      "https://cdn.pixabay.com/photo/2015/04/23/17/41/javascript-736400_960_720.png",
  },
  {
    id:3,
    name: "React JS",
    iconName: "logos:react",
    value: 90,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:4,
    name: "Node JS",
    iconName: "logos:nodejs",
    value: 70,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:5,
    name: "Redux",
    iconName: "logos:redux",
    value: 95,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:6,
    name: "Sass",
    iconName: "logos:sass",
    value: 75,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:7,
    name: "Firebase",
    iconName: "logos:firebase",
    value: 70,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:8,
    name: "Mongo DB",
    iconName: "vscode-icons:file-type-mongo",
    value: 75,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:9,
    name: "Express JS",
    iconName: "simple-icons:express",
    value: 90,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:10,
    name: "C/C++",
    iconName: "logos:c-plusplus",
    value: 90,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:11,
    name: "Java",
    iconName: "logos:java",
    value: 70,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:12,
    name: "Flutter",
    iconName: "logos:flutter",
    value: 65,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:13,
    name: "Python",
    iconName: "logos:python",
    value: 80,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:14,
    name: "React native",
    iconName: "tabler:brand-react-native",
    value: 60,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
  {
    id:15,
    name: "Bootstrap",
    iconName: "logos:bootstrap",
    value: 80,
    imageUrl:
      "https://www.andreasreiterer.at/wp-content/uploads/2017/11/react-logo-825x510.jpg",
  },
];

export default skills;
